export default __webpack_public_path__ + "static/media/WM0440.34I-43835_-26159_0.87ca5922.jpg";